/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerpicturefailed2Inputs */

const en_organizerpicturefailed2 = /** @type {(inputs: Organizerpicturefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The picture could not be uploaded. Try again on your page.`)
};

const de_organizerpicturefailed2 = /** @type {(inputs: Organizerpicturefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Bild konnte nicht hochgeladen werden. Versuch es auf deiner Seite noch einmal.`)
};

/**
* | output |
* | --- |
* | "The picture could not be uploaded. Try again on your page." |
*
* @param {Organizerpicturefailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerpicturefailed2 = /** @type {((inputs?: Organizerpicturefailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerpicturefailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerpicturefailed2(inputs)
	return de_organizerpicturefailed2(inputs)
});
export { organizerpicturefailed2 as "organizerPictureFailed" }